import { Controller } from "@hotwired/stimulus";
import { turboConfirm } from "../../utils/ds_confirm.js";

// The DS confirmation for a form Turbo does not submit (data-turbo="false":
// files sent, a full page back). Turbo reads data-turbo-confirm only on the
// forms it submits; this controller reads the same attributes on the button
// pressed, asks with the same modal, then submits again with that button.
//
//   <form data-turbo="false" data-controller="confirm-submit"
//         data-action="submit->confirm-submit#ask">
//     <button name="commit_action" value="send"
//             data-turbo-confirm="Envoyer ce communiqué ?"
//             data-confirm-summary-from="[data-testid='recipients-counter']">
//
// A button without data-turbo-confirm (« Enregistrer le brouillon ») submits
// at once.
export default class extends Controller {
  async ask(event) {
    const submitter = event.submitter;
    const message = submitter?.dataset?.turboConfirm;
    if (!message) return;
    if (this.confirmedSubmitter === submitter) {
      this.confirmedSubmitter = null;
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    if (!(await turboConfirm(message, this.element, submitter))) return;

    this.confirmedSubmitter = submitter;
    this.element.requestSubmit(submitter);
  }
}
